<template>
	<div
			id="quote-request-page"
			class="home"
			:class="theme">
		<nav-bar></nav-bar>
		<!--<img src="../assets/img/n1.jpg" alt="">-->
		<swiper :options="swiperOption" ref="mySwiper8">
			<swiper-slide>
				<div style="height: 100%; background-image: url('../assets/img/n1.jpg'); background-size: cover; background-repeat: no-repeat;">
					<div class="slide-center">
						<h1 class="page__title-white">{{ $t('Budget_request') }}</h1>
					</div>
				</div>
			</swiper-slide>
		</swiper>
		<div id="quote-form" class="quote-request">
			<h1 class="quote-request__title text-center">{{ $t('Budget_request') }}</h1>
			<message
					v-if="error"
					:text="error"
					@closeMessage="closeMessage">
			</message>
			<success-message
					v-if="success_message"
					:text="success_message"
					@closeMessage="closeMessage">
			</success-message>
			<form class="quote-request__form">
				<h3>{{ $t('Petitioner_data') }}</h3>
				<field
						v-for="field in petitioner_fields"
						v-model="field.value"
						:name="field.name"
						:type="field.type"
						:placeholder="field.placeholder"
						:autofocus="field.autofocus">
				</field>

				<h3>{{ $t('Data_of_property_to_be_appraised') }}</h3>
				<field
						v-for="field in property_fields"
						v-model="field.value"
						:name="field.name"
						:type="field.type"
						:placeholder="field.placeholder"
						:autofocus="field.autofocus">
				</field>

				<p>* {{ $t('Required_fields') }}</p>

				<message
						v-if="error"
						:text="error"
						@closeMessage="closeMessage">
				</message>
				<success-message
						v-if="success_message"
						:text="success_message"
						@closeMessage="closeMessage">
				</success-message>

				<button
						class="quote-request__form__button"
						@click.prevent="onSend"
						@keyup.enter="onSend">
					Enviar
				</button>
			</form>
		</div>
		<logo-bar></logo-bar>
		<footer-bar></footer-bar>
	</div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Vue from 'vue'
    import { localStorageMixin } from '../mixins'
    import Field from '../components/Field.vue'
    import Message from '../components/Message.vue'
    import SuccessMessage from '../components/SuccessMessage.vue'
    import FooterBar from '../components/FooterBar.vue'
    import NavBar from '../components/NavBar.vue'
    import LogoBar from '../components/LogoBar.vue'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    export default {
        name: 'quote-request',

        mixins: [localStorageMixin],

        components: {
            Field,
            Message,
            SuccessMessage,
            FooterBar,
            LogoBar,
            NavBar,
            swiper,
            swiperSlide
        },

        data: () => ({
            petitioner_fields: {
                name: {
                    name: Vue.i18n.translate('Name')+' *',
                    value: '',
                    type: 'text',
                    placeholder: Vue.i18n.translate('Name'),
                    autofocus: true
                },
                surnames: {
                    name: Vue.i18n.translate('Surnames')+' *',
                    value: '',
                    type: 'text',
                    placeholder: Vue.i18n.translate('Surnames'),
                    autofocus: false
                },
                company: {
                    name: Vue.i18n.translate('Company_or_business_name'),
                    value: '',
                    type: 'text',
                    placeholder: Vue.i18n.translate('Company_or_business_name'),
                    autofocus: false
                },
                email: {
                    name: Vue.i18n.translate('Email_Address')+' *',
                    value: '',
                    type: 'email',
                    placeholder: 'email@email.com',
                    autofocus: false
                },
                telephone: {
                    name: Vue.i18n.translate('Telephone_contact')+' *',
                    value: '',
                    type: 'text',
                    placeholder: Vue.i18n.translate('Telephone_contact'),
                    autofocus: false
                }
            },
            property_fields: {
                property_type: {
                    name: Vue.i18n.translate('Type_of_property')+' *',
                    value: '',
                    type: 'text',
                    placeholder: Vue.i18n.translate('Type_of_property'),
                    autofocus: false
                },
                address: {
                    name: Vue.i18n.translate('Address')+' *',
                    value: '',
                    type: 'text',
                    placeholder: Vue.i18n.translate('Address'),
                    autofocus: false
                },
                postal_code: {
                    name: Vue.i18n.translate('Postal_code')+' *',
                    value: '',
                    type: 'text',
                    placeholder: Vue.i18n.translate('Postal_code'),
                    autofocus: false
                },
                municipality: {
                    name: Vue.i18n.translate('Municipality')+' *',
                    value: '',
                    type: 'text',
                    placeholder: Vue.i18n.translate('Municipality'),
                    autofocus: false
                },
                province: {
                    name: Vue.i18n.translate('Province'),
                    value: '',
                    type: 'text',
                    placeholder: Vue.i18n.translate('Province'),
                    autofocus: false
                },
                property_area: {
                    name: Vue.i18n.translate('Approximate_property_area')+' *',
                    value: '',
                    type: 'text',
                    placeholder: Vue.i18n.translate('Approximate_property_area'),
                    autofocus: false
                },
                cadastral_reference: {
                    name: Vue.i18n.translate('Cadastral_reference'),
                    value: '',
                    type: 'text',
                    placeholder: Vue.i18n.translate('Cadastral_reference'),
                    autofocus: false
                },
                appraisal_purpose: {
                    name: Vue.i18n.translate('Appraisal_purpose')+' *',
                    value: '',
                    type: 'text',
                    placeholder: Vue.i18n.translate('Appraisal_purpose'),
                    autofocus: false
                },
                notes: {
                    name: Vue.i18n.translate('Notes'),
                    value: '',
                    type: 'textarea',
                    placeholder: Vue.i18n.translate('Notes'),
                    autofocus: false
                }
            },
            error: null,
			success_message: null,
            swiperOption: {
                spaceBetween: 30,
                centeredSlides: true,
                autoplay: 4000,
                autoplayDisableOnInteraction: false,
                effect: 'fade',
                speed: 2000
            }
        }),

        created () {
            if (this.$route.query.email) {
                this.petitioner_fields.email.value = this.$route.query.email
            }
        },

        computed: {
            ...mapGetters(['user',
                'theme'])
        },

        methods: {
            ...mapActions(['LOG_IN_USER',
                'UPDATE_BUDGET_REQUEST'
            ]),

            onSend(){

                if (this.petitioner_fields.email.value.length === 0) {
                    this.error = Vue.i18n.translate('Please_enter_an_email_address') + '.'
                    return
                }

                const email_regex = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/

                if (email_regex.test(this.petitioner_fields.email.value) === false) {
                    this.error = Vue.i18n.translate('Invalid_email_address') + '.'
                    return false;
                }

                if (this.petitioner_fields.name.value.length === 0) {
                    this.error = Vue.i18n.translate('Please_enter_a_name') + '.'
                    return
                }

                if (this.petitioner_fields.surnames.value.length === 0) {
                    this.error = Vue.i18n.translate('Please_enter_a_surname') + '.'
                    return
                }

                if (this.petitioner_fields.telephone.value.length === 0) {
                    this.error = Vue.i18n.translate('Please_enter_a_telephone_number') + '.'
                    return
                }

                if (this.property_fields.property_type.value.length === 0) {
                    this.error = Vue.i18n.translate('Please_enter_the_type_of_property') + '.'
                    return
                }

                if (this.property_fields.address.value.length === 0) {
                    this.error = Vue.i18n.translate('Please_enter_the_address_of_the_property') + '.'
                    return
                }

                if (this.property_fields.postal_code.value.length === 0) {
                    this.error = Vue.i18n.translate('Please_enter_the_postal_code') + '.'
                    return
                }

                if (this.property_fields.municipality.value.length === 0) {
                    this.error = Vue.i18n.translate('Please_enter_the_municipality') + '.'
                    return
                }

                if (this.property_fields.property_area.value.length === 0) {
                    this.error = Vue.i18n.translate('Please_enter_the_area_of_the_property') + '.'
                    return
                }

                if (this.property_fields.appraisal_purpose.value.length === 0) {
                    this.error = Vue.i18n.translate('Please_enter_the_purpose_of_the_appraisal') + '.'
                    return
                }

                const data = {
                    petitioner_name: this.petitioner_fields.name.value,
                    petitioner_surnames: this.petitioner_fields.surnames.value,
                    petitioner_company: this.petitioner_fields.company.value,
                    petitioner_email: this.petitioner_fields.email.value,
                    petitioner_telephone: this.petitioner_fields.telephone.value,
                    property_type: this.property_fields.property_type.value,
                    property_address: this.property_fields.address.value,
                    property_postal_code: this.property_fields.postal_code.value,
                    property_municipality: this.property_fields.municipality.value,
                    property_province: this.property_fields.province.value,
                    property_area: this.property_fields.property_area.value,
                    property_cadastral_reference: this.property_fields.cadastral_reference.value,
                    property_appraisal_purpose: this.property_fields.appraisal_purpose.value,
                    property_notes: this.property_fields.notes.value
                }

				 this.UPDATE_BUDGET_REQUEST(data)
				 .then(() => {
				 console.log('update_budget_request from onSend() at QuoteRequest')
					 this.error = null
					 this.success_message = Vue.i18n.translate('Request_successfully_sent')
				 })
				 .catch((error) => {
				 this.error = error.message
				 })

            },

            onLogIn () {
                if (this.petitioner_fields.email.value.length === 0) {
                    this.error = Vue.i18n.translate('Please_enter_an_email_address') + '.'
                    return
                }

                if (this.petitioner_fields.password.value.length === 0) {
                    this.error = 'Please enter a password.'
                    return
                }

                const data = {
                    email: this.petitioner_fields.email.value,
                    // password: this.fields.password.value
                }
                this.LOG_IN_USER(data)
                    .then(() => {
                        this.ls_pushUser(this.user)
                        this.$router.push({name: 'app'})
                    })
                    .catch((error) => {
                        this.error = error.message
                    })
            },

            closeMessage () {
                this.error = null
            }
        },

        head: {
            title: {
                inner: 'Request a quote'
            }
        }

    }
</script>

<style scoped>
	.swiper-container {
		height: 40vh;
		width: 100%;
	}
	.slide-img {
		width: 100%;
		height: auto;
	}
</style>


// WEBPACK FOOTER //
// QuoteRequest.vue?2815568d